export default __webpack_public_path__ + "static/media/dots.b237910c.svg";